import styled from "styled-components";


export const Img=styled.img` 
    position:absolute;
    width:70%;
    z-index:0;
    
`;
